import { LOCALSTORAGE_TEAM_SELECTED_KEY } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { Layout, LayoutProps } from "@/Layout";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { SupportMessage } from "./support-message";

export const LayoutFatalErrorOccured = ({
  showNavMain = false,
  showNavSearch = false,
  showTeamSwitcher = false,
  showTeamTrial = false,
  ...props
}: LayoutProps) => {
  const { t } = useTranslation();

  const reset = () => {
    localStorage.removeItem(LOCALSTORAGE_TEAM_SELECTED_KEY);
    window.location.reload();
  };

  return (
    <Layout
      showNavMain={showNavMain}
      showNavSearch={showNavSearch}
      showTeamSwitcher={showTeamSwitcher}
      showTeamTrial={showTeamTrial}
      {...props}
    >
      <div className={cn("flex-col py-6 space-y-3 text-center")}>
        <p className="text-lg font-bold text-center">
          {t("components.layoutFatalError.title")}
        </p>
        <Button onClick={reset}>
          {t("components.layoutFatalError.resetSession")}
        </Button>
        <SupportMessage />
      </div>
    </Layout>
  );
};
